module.exports = __webpack_public_path__ + "static/media/9DESA34.fcc8eecf.jpg";